export const removeHighlightText = (text: string) =>
	text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
